import { TPL_CODE } from '@/constants/constants.ts'
import { formatDateToYYYYMMDD } from '@/utils/formatDate.js'

export default {
  methods: {
    getAnalyticsData () {
      let option = 'no_change_plan'

      if (this.$store.state.motor.isDowngradePossible) {
        option = 'downgrade'
      } else if (this.$store.state.motor.isUpgradePossible) {
        option = 'upgrade'
      }

      return {
        expiration_date: formatDateToYYYYMMDD(this.$store.state.renew?.policyInfo?.polEndDate),
        plan_name: this.$store.state.renew?.policyInfo?.prodCode === TPL_CODE ? 'TPL' : 'OD',
        option
      }
    }
  }
}
